function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 283.465"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.464 198.425V21.26H0v177.166h127.539v35.434H77.953v28.346h127.559V233.86h-49.627v-35.434h127.579zM28.347 49.607h226.772V170.08H28.347V49.607z",
  id: "TV"
})));